import { TranscriptProps } from "../../components/Recording";
import { useClipTranscriptQuery } from "../../graphql";
import useClipNotes from "./useClipNotes";

const useClipTranscript = ({
  clipId,
  callId,
}: {
  clipId: string;
  callId: string;
}): Pick<
  TranscriptProps,
  "transcript" | "notesToHighlight" | "loading" | "error"
> => {
  const { data, loading, error } = useClipTranscriptQuery({
    variables: { clipId },
  });
  const { notes } = useClipNotes({ callId, clipId });

  return {
    transcript: data?.clip?.transcript ?? [],
    notesToHighlight: notes,
    loading,
    error,
  };
};

export default useClipTranscript;
